/**
 * Opportunity contracts (RBAC area: `sales`).
 *
 * An opportunity is a sales deal tracked against a customer ("Company"): who is
 * working it (sales rep), the primary contact, the expected close date, the kind
 * of work (service category = "Type"), a sales `stage`, a lifecycle `status`, an
 * append-only running notes log, and a list of candidate products.
 */
export const OPPORTUNITY_STAGES = [
    'lead',
    'business_discussion',
    'quoted',
    'committed',
    'won',
];
export const OPPORTUNITY_STAGE_LABELS = {
    lead: 'Lead',
    business_discussion: 'Business Discussion',
    quoted: 'Quoted',
    committed: 'Committed',
    won: 'Won',
};
export const OPPORTUNITY_STATUSES = [
    'open',
    'order_approved',
    'won',
    'lost_competitor',
    'lost_project_cancelled',
];
export const OPPORTUNITY_STATUS_LABELS = {
    open: 'Open',
    order_approved: 'Order Approved',
    won: 'Won',
    lost_competitor: 'Lost - Competitor',
    lost_project_cancelled: 'Lost - Project Cancelled',
};
/** Whether the opportunity is net-new business or an upsell to an existing customer. */
export const OPPORTUNITY_KINDS = ['new', 'upsell'];
export const OPPORTUNITY_KIND_LABELS = {
    new: 'New',
    upsell: 'Upsell',
};
/** Distinguishes a formal file attachment from an inline note image. */
export const OPPORTUNITY_ATTACHMENT_KINDS = ['attachment', 'image'];
//# sourceMappingURL=opportunity.js.map